import { Box, Grid, useTheme } from "@mui/material";
import {
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { RHookFormMaskedTextFieldWithVerifyLabel } from "../../RHookFormMaskedTextFieldWithVerifyLabel";

interface IAccountantBankInfoSetupFieldsPanel {
	onVerifyBankClickedHandler: () => void;
}
export const AccountantBankInfoSetupFieldsPanel: FC<
	IAccountantBankInfoSetupFieldsPanel
> = ({
	onVerifyBankClickedHandler
}) => {
		const theme = useTheme();
		return (
			<Box
				sx={{
					padding: "0",
					"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
				}}
			>
				<RHookFormMaskedTextFieldWithVerifyLabel
					id="accountNo"
					testId={`accountNo`}
					placeholder={"000000000000000000"}
					inputMaskPattern={"000000000000000000"}
					label={
						<>
							<Grid>Bank Account No.&nbsp;
								<span style={{ color: theme.palette.primary.light, cursor: "pointer" }} onClick={onVerifyBankClickedHandler}>
									[Verify]
								</span>
							</Grid>
						</>
					}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Branch/Transit No."
					id="branchTransitNumber"
					testId={`branchTransitNumber`}
					placeholder={"00000"}
					inputMaskPattern={"00000"}
				/>
				<RHookFormMaskedTextFieldWithLabel
					label="Bank/Financial Institution No."
					id="bankFinancialNo"
					testId={`bankFinancialNo`}
					placeholder={"0000"}
					inputMaskPattern={"0000"}
				/>

				<RHookFormTextFieldWithLabel
					label="Transaction Alert Email (multiple emails can be used in comma separation)"
					id="transactionAlertEmail"
					testId={`Status`}
				/>
			</Box>
		);
	};
